import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { canShareToStory, shareReferralStory } from '../ton/notify';
import { gaEvent } from '../analytics';

interface ShareStoryButtonProps {
  /** The inviter's numeric referral key. */
  referrerKey: number;
  /** Which bot the story invites into (default `'main'`). */
  bot?: 'main' | 'team';
  /** Optional label override (defaults to the main-bot "Share to Story"). */
  label?: string;
}

/**
 * "Share to Story" button: posts a branded Pyramida story (bot-rendered QR
 * image) with the user's referral caption and a tappable link widget that opens
 * the bot deep link. Renders nothing when the client can't share to stories or
 * the story image URL isn't configured.
 */
export function ShareStoryButton({ referrerKey, bot = 'main', label }: ShareStoryButtonProps) {
  const { t } = useTranslation();
  if (!canShareToStory()) return null;

  const handleShare = () => {
    gaEvent('share_story', { bot });
    void shareReferralStory(
      referrerKey,
      {
        caption: bot === 'team' ? t('share.captionTeam') : t('share.caption'),
        widgetName: t('refLink.storyWidget'),
        prizeLabel: t('refLink.storyPrizePool'),
      },
      bot,
    );
  };

  return (
    <button type="button" className="share-btn share-btn--story" onClick={handleShare}>
      <Sparkles size={16} aria-hidden="true" />{' '}
      {label ?? (bot === 'team' ? t('refLink.shareStoryTeam') : t('refLink.shareStory'))}
    </button>
  );
}
